import React, { useCallback, useState } from "react";
import { putUpdatePrintFileFetch } from "../../features/action/fetchPrint";
import { ShowItem } from "../common/ShowItem";
import { getImageFileFetch } from "../../features/action/fetchImage";
import { useDispatch, useSelector } from "react-redux";
import { FaPrint } from "react-icons/fa6";
import { DateTo, MembersBlock } from "./mainBloks";
import { DateFrom } from "./mainBloks";
// import { extractDimensions, getMachineType, calculatePrintTime } from "../common/FabricTimer";

const StripComponent = ({ i, color }) => {
  const { image, loadingImage } = useSelector((state) => state.imageFile);
  const [showItems, setShowItems] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);
  const dispatch = useDispatch();

  const handleClickPrint = useCallback(async (id, folderFabric, fileName) => {
    if (updatingId === id) return;
    setUpdatingId(id);
    try {
      await dispatch(putUpdatePrintFileFetch(id, folderFabric, fileName));
    } finally {
      setUpdatingId(null);
    }
  }, [dispatch, updatingId]);

  // Код таймера для синхронизации с другими компьютерами - закомментировано
  // const dimensions = extractDimensions(fileName)
  // const machineType = getMachineType(folderFabric)
  // const itemSeconds = dimensions
  //   ? calculatePrintTime(dimensions.width, dimensions.height, machineType) * dimensions.quantity
  //   : calculatePrintTime(1520, 2550, machineType)
  //
  // const timerId = `fabric_${folderFabric}`
  // const storageKey = `fabric_timer_${timerId}_seconds`
  // const current = parseInt(localStorage.getItem(storageKey) || '0', 10)
  // localStorage.setItem(storageKey, Math.max(current - itemSeconds, 0).toString())
  //
  // window.dispatchEvent(new CustomEvent('timer_subtract', { detail: { id: timerId, seconds: itemSeconds } }))
  // window.dispatchEvent(new CustomEvent('timer_set_printing', { detail: { id: timerId, isPrinting: true } }))

  const handleOpenImage = (key, url) => {
    setShowItems(key);
    dispatch(getImageFileFetch(url));
  };
  return (
    <React.Fragment>
      {i.item.map((a, k1) => (
        <div
          className="flex flex-row h-[64px] w-[100%] mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb] mx-auto"
          key={k1}
        >
          {DateFrom(a.toDate, color)}
          {DateTo(a.date)}
          {MembersBlock(a.manager, a.designer)}

          <div className="w-[19.19%]  content-center">
            <div
              className="flex bg-[#739D00] h-[62px] justify-center items-center"
              onClick={() => handleOpenImage(k1, a.image)}
            >
              <p className="text-[2.3vw] font-rubik font-black  text-white">
                {a.fileName.slice(0, 4)}
              </p>
            </div>
          </div>
          {/* ----------------------------------------Show IMG----------------------------------------------------- */}
          {showItems === k1 && (
            <ShowItem
              url={image}
              setShowItems={setShowItems}
              loadingImage={loadingImage}
            />
          )}
          {/* --------------------------------------------------------------------------------------------- */}
          <div className="w-[31.57%] content-center">
            <p className="text-[1vw] font-rubik font-light text-xl text-black">
              {a.fileName.slice(4)}
              {/* fullUrl "/mnt/ira_rip/26.10/Flag160/2330 1 152x339cm x2.bmp" */}
            </p>
          </div>
          {/* -----------------------------------------print update---------------------------------------------------- */}
          <button
            type="button"
            className=" w-[10.10%] bg-[#739D00] content-center rounded-r-[8px] hover:bg-[#FF3D00] "
            onClick={() => handleClickPrint(a._id, i.folderFabric, a.fileName)}
            disabled={updatingId === a._id}
          >
            <FaPrint className="text-white text-[2vw]" />
          </button>
          {/* --------------------------------------------------------------------------------------------- */}
        </div>
      ))}
    </React.Fragment>
  );
};

export const Strip = React.memo(StripComponent);
